// The languages the site opens in. French and English carry every word of
// every screen; the four added ones carry the shell (navigation, search,
// common words) and fall back to English elsewhere until their tables are
// written — a page reads `L[lang] || L.en` and never shows a bare key.
// Wolof is `partial` (owner, 2026-10-07): its presentation texts are Wolof
// and every other word is French, so the rest of the site reads it as French
// (contentLang) and only the presentation tables carry a `wo` (i18n/wolof.js).
export const LANGUAGES = [
  { code: "fr", name: "Français", dir: "ltr" },
  { code: "en", name: "English", dir: "ltr" },
  { code: "es", name: "Español", dir: "ltr" },
  { code: "pt", name: "Português", dir: "ltr" },
  { code: "ar", name: "العربية", dir: "rtl" },
  { code: "zh", name: "中文", dir: "ltr" },
  { code: "wo", name: "Wolof", dir: "ltr", partial: true },
];
// The languages with every word: what the payment form, the identity check,
// a partner's language and the "6 langues" fact go by.
export const SUPPORTED_LANGS = LANGUAGES.filter((l) => !l.partial).map((l) => l.code);
// Every language a visitor can choose.
export const SITE_LANGS = LANGUAGES.map((l) => l.code);
// The language of everything but the presentation texts: French under Wolof.
export const contentLang = (code) => (code === "wo" ? "fr" : code);
export const isSupportedLang = (code) => SUPPORTED_LANGS.includes(code);
export const directionOf = (code) => (LANGUAGES.find((l) => l.code === code) || LANGUAGES[0]).dir;
export const languageName = (code) => (LANGUAGES.find((l) => l.code === code) || {}).name || code;

// A page's words in the visitor's language, English when that table has
// not been translated yet. Never a bare key, never a crash.
export const pick = (table, code) => (table && (table[code] || table.en)) || {};

// Intl locales for dates and numbers.
const LOCALES = { fr: "fr-FR", en: "en-US", es: "es-ES", pt: "pt-PT", ar: "ar", zh: "zh-CN" };
export const localeOf = (code) => LOCALES[code] || LOCALES.en;
